import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// 主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100409547
export const world_cup_fb_config = createAsyncThunk(
  'WorldCup/live/activity/world_cup_fb_config',
  async (kick_id: KickEnum, store: any) => {
    const {env} = store.getState()
    const resp = await http.post<HiyaRes<Omit<InitialStateType, 'kick_id'>>>(
      '/live/activity/world_cup_fb_config',
      {
        ...env.deviceinfo,
        kick_id,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 抽奖 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100409550
export const world_cup_fb_kick = createAsyncThunk(
  'WorldCup//live/activity/world_cup_fb_kick',
  async (arg, store: any) => {
    const {env, GameWorldCup} = store.getState()
    const resp = await http.post<
      HiyaRes<{
        status: 1 | 2
        err_msg: string
        kick_info: {
          id: number
        }
      }>
    >(
      '/live/activity/world_cup_fb_kick',
      {
        ...env.deviceinfo,
        kick_id: GameWorldCup.kick_id,
      },
      {store}
    )
    return resp.data.data
  }
)
export enum KickEnum {
  level0,
  level1,
  level2,
}
interface InitialStateType {
  kick_id?: KickEnum
  amount?: number
  date?: string
  lottery_Records?: Array<{
    Name: string
    GiftName: string
  }>
  lottery_infos?: Array<{
    id: number
    desc: string
    icon: string
    num: number
    value: number
  }>
  lottery_historys?: Array<{
    id: number
    lt: string
    icon: string
    value: number
    desc: string
  }>
}

const initialState: InitialStateType = {}

export const WorldCupSlice = createSlice({
  name: 'WorldCup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(world_cup_fb_config.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        kick_id: action.meta.arg,
      })
    })
  },
})

export default WorldCupSlice.reducer
export const WorldCupActions = WorldCupSlice.actions
export const useGameWorldCup = () => {
  return useSelector((state) => state.Animal_Crow)
}
